// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Eg8f1","right":"styles_right__1dSHT"};